/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterDataCategoryListResponse {
    getFixupPrototypeFunction() { return MasterDataCategoryListResponse.fixupPrototype; }

    static newInstance(model: Partial<MasterDataCategoryListResponse>): MasterDataCategoryListResponse {
        let obj = Object.assign(new MasterDataCategoryListResponse(), model);
        MasterDataCategoryListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterDataCategoryListResponse>): MasterDataCategoryListResponse {
        if (!model) return null;
        return MasterDataCategoryListResponse.newInstance(<MasterDataCategoryListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterDataCategoryListResponse) {
        if (!obj) return;

        models.MasterDataCategoryListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterDataCategoryListResponse): boolean {
        Object.setPrototypeOf(obj, MasterDataCategoryListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.MasterDataCategoryDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Master Data Category List
     */
    results: Array<models.MasterDataCategoryDetails>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
